<template>
    <el-row :gutter="20" class="main_block">
        <div class="mianContent" v-if="!isLogout">
            <div class="tagView">
                <div class="title_aside"></div>
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>安全中心</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <el-row :gutter="20" type="flex" class="row-bg" justify="space-around">
                <el-col :span="16">
                    <div class="contentBox">
                        <div class="tel">
                            <p>修改密码</p>
                            <el-button round @click="editPwd">修改</el-button>
                        </div>
                        <el-divider></el-divider>
                        <div class="tel">
                            <p>注销账号</p>
                            <el-button round @click="annul">注销</el-button>
                        </div>
                        <el-divider></el-divider>
                    </div>
                </el-col>
            </el-row>
        </div>

        <!-- 修改密码 -->
        <el-dialog title="修改密码" :visible.sync="editPwdDia" width="550px" top="27vh" class="copyDialog copyDialog3" center>
            <el-row :gutter="22" type="flex" class="row-bg" justify="center">
                <el-col :span="22">
                    <template v-if="editPwdStep==1">
                        <p class="videntity" v-if="pwdVerifyType=='phone'">为验证您的身份，需要使用您的手机<b>{{userdata.phone}}</b>收取短信验证码。</p>
                        <p class="videntity" v-else-if="pwdVerifyType=='email'">为验证您的身份，需要使用您的邮箱<b>{{userdata.email}}</b>收取验证码。</p>
                    </template>
                    <el-form :model="codeForm" :rules="rulesyzm" ref="codeForm" v-show="editPwdStep==1">
                        <el-form-item prop="code" style="margin-top:15px">
                            <el-input type="text" v-model="codeForm.code" autocomplete="off" clearable class="copyDialog3Code" placeholder="请输入验证码">
                                <span slot="append" class="yzm" :disabled="disabled" @click="getVerificationCode()">{{ yzmtext }}</span>
                            </el-input>
                        </el-form-item>
                    </el-form>
                    <div class="changeBind" v-if="editPwdStep==1">
                        <template v-if="userdata.phone&&userdata.email">
                            <span class="verify-switch-item" @click="toggleVerifyType">使用{{pwdVerifyType=='phone'?'邮箱':'手机号'}}验证</span>
                            <span class="verify-divider"></span>
                        </template>
                        <span class="verify-switch-item" @click="editPwdStep=0">输入旧密码验证</span>
                    </div>
                    <el-form :model="modifyPwd" :rules="modifyPwdRules" ref="modifyPwd" status-icon label-width="85px" v-show="editPwdStep==0">
                        <el-form-item label="旧密码" prop="oldPassword">
                            <el-input type="password" v-model="modifyPwd.oldPassword" autocomplete="off" placeholder="请输入旧密码"></el-input>
                        </el-form-item>
                        <el-form-item label="新密码" prop="newPassword">
                            <el-input type="password" v-model="modifyPwd.newPassword" autocomplete="off" placeholder="请输入6-20位的字母或数字"></el-input>
                        </el-form-item>
                        <el-form-item label="确认密码" prop="confirmPwd">
                            <el-input type="password" v-model="modifyPwd.confirmPwd" autocomplete="off" placeholder="请确认新密码"></el-input>
                        </el-form-item>
                    </el-form>
                    <el-form :model="modify" :rules="modifyRules" status-icon ref="modify" v-show="editPwdStep==2">
                        <el-form-item label="新密码" label-width="85px" prop="password">
                            <el-input prop="password" type="password" v-model="modify.password" autocomplete="off"
                                placeholder="请输入6-20位的字母或数字"></el-input>
                        </el-form-item>
                        <el-form-item label="确认密码" label-width="85px" prop="confirm">
                            <el-input prop="confirm" type="password" v-model="modify.confirm" autocomplete="off" placeholder="请再次输入新密码"></el-input>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <template v-if="editPwdStep==0">
                    <el-button round class="next" @click="subModifyPwd('modifyPwd')" type="primary">确定</el-button>
                    <el-button round @click="editPwdDia = false">取消</el-button>
                </template>
                <template v-else-if="editPwdStep==1">
                    <el-button round class="next" @click="subIdentity('codeForm',1)" type="primary">下一步</el-button>
                    <el-button round @click="editPwdDia = false">取消</el-button>
                </template>
                <template v-else>
                    <el-button round @click="editPwdStep = 1">上一步</el-button>
                    <el-button round class="next" @click="submodify('modify')" type="primary">确定</el-button>
                </template>
            </span>
        </el-dialog>
        <el-dialog title="请选择任意一种方式修改密码" :visible.sync="bindAccountDia" width="700px" top="27vh" class="copyDialog copyDialog3" center
            :close-on-click-modal="false">
            <ul class="pwd-option-list">
                <li @click="handlePasswordMethod('oldPwd')">
                    <dl>
                        <dd>
                            <h3>通过原密码修改</h3>
                            <span>需输入原密码后修改密码</span>
                        </dd>
                    </dl>
                </li>
                <li @click="handlePasswordMethod('bindPhone')">
                    <dl>
                        <dd>
                            <h3>通过绑定手机号/邮箱修改</h3>
                            <span>需先绑定手机号或邮箱后修改密码</span>
                        </dd>
                    </dl>
                </li>
            </ul>
        </el-dialog>

        <!-- 注销身份验证 -->
        <el-dialog title="身份验证" :visible.sync="diaIdentity" width="550px" top="27vh" class="copyDialog copyDialog3" center
            :close-on-click-modal="false">
            <el-row :gutter="20" type="flex" class="row-bg" justify="center">
                <el-col :span="20">
                    <p class="videntity" v-if="userdata.phone">为验证您的身份，需要使用您的手机<b>{{userdata.phone}}</b>收取短信验证码。</p>
                    <p class="videntity" v-else-if="userdata.email">为验证您的身份，需要使用您的邮箱<b>{{userdata.email}}</b>收取验证码。</p>
                    <el-form :model="yzmForm" :rules="rulesyzm" ref="yzmForm" status-icon label-width="0px">
                        <el-form-item prop="yzm" style="margin-top:15px">
                            <el-input type="text" v-model="yzmForm.yzm" autocomplete="off" clearable class="copyDialog3Code" placeholder="请输入验证码">
                                <span slot="append" class="yzm" :disabled="disabled" @click="getVerificationCode()">{{ yzmtext }}</span>
                            </el-input>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button round type="primary" @click="subIdentity('yzmForm',2)">提交</el-button>
                <el-button round class="next" @click="diaIdentity=false">取消</el-button>
            </span>
        </el-dialog>
        <el-dialog title="提示" :visible.sync="noAnnulDia" width="445px" top="27vh" class="copyDialog copyDialog3" center :close-on-click-modal="false">
            <div class="hint">
                <p><i class="el-icon-ali-jinggao"></i></p>
                <p>您的账号不符合自助注销条件，请联系客服进行账号注销。</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button round type="primary" @click="noAnnulDia=false">确定</el-button>
            </span>
        </el-dialog>

        <div id="captcha-element"></div>
    </el-row>
</template>

<script>
import { recover, sendMsg, verifyCode, changePassword } from '@http/userCenter/index'
import { mapState } from 'vuex'
import { hexMD5 } from '@/utils/md5.js'
import NoTrace from '@/utils/noTrace'
import qs from 'qs'
let interval = null
let time = 61
const reg = /^[A-Za-z0-9]{6,20}$/
const validatePassword = (_rule, value, callback) => {
    if (!value || !reg.test(value)) {
        callback(new Error('请输入6-20位的字母或数字'))
    }
    callback()
}
const validateConfirm = (target) => (_rule, value, callback) => {
    if (value == target()) {
        callback()
    } else {
        callback(new Error('两次密码输入不一致'))
    }
}
export default {
    name: 'security',
    components: {},
    data() {
        var validateyzm = (rule, value, callback) => {
            if (!value || value.trim().length == 0) {
                callback(new Error('请输入验证码'))
                return
            }
            if (this.msg) {
                callback(new Error(this.msg))
                return
            }
            callback()
        }
        return {
            editPwdDia: false,
            isLogout: false,
            editPwdStep: 1,
            pwdVerifyType: 'phone',
            modify: {
                loginName: '',
                code: '',
                password: '',
                confirm: '',
                signupType: '',
            },
            modifyRules: {
                password: [{ validator: validatePassword, trigger: 'blur' }],
                confirm: [
                    { validator: validateConfirm(() => this.modify.password), trigger: 'blur' },
                ],
                code: [{ validator: validateyzm }],
            },
            diaIdentity: false,
            nvc: '',
            yzmtext: '获取验证码',
            disabled: false,
            currentTime: 61,
            yzmForm: {
                yzm: '',
            },
            codeForm: {
                code: '',
            },
            modifyPwd: {
                oldPassword: '',
                newPassword: '',
                confirmPwd: '',
            },
            modifyPwdRules: {
                oldPassword: [{ validator: validatePassword, trigger: 'blur' }],
                newPassword: [{ validator: validatePassword, trigger: 'blur' }],
                confirmPwd: [
                    {
                        validator: validateConfirm(() => this.modifyPwd.newPassword),
                        trigger: 'blur',
                    },
                ],
            },
            rulesyzm: {
                yzm: [{ validator: validateyzm }],
                code: [{ validator: validateyzm }],
            },
            noAnnulDia: false,
            bindAccountDia: false,
        }
    },
    watch: {
        editPwdDia(val) {
            this.editPwdStep = 1
            this.resetYzm()
            this.modifyPwd.oldPassword = ''
            this.modifyPwd.newPassword = ''
            this.modifyPwd.confirmPwd = ''
            if (val) {
                this.$nextTick(() => {
                    this.$refs.codeForm && this.$refs.codeForm.resetFields()
                    this.$refs.modifyPwd && this.$refs.modifyPwd.resetFields()
                })
                this.codeForm.code = ''
                zhuge.track('用户中心_修改密码', { 渠道: this.channelCodeValue })
            }
        },
        diaIdentity(val) {
            this.resetYzm()
            if (val) {
                this.$nextTick(() => {
                    this.$refs.yzmForm && this.$refs.yzmForm.resetFields()
                })
                this.yzmForm.yzm = ''
            }
        },
    },
    computed: {
        ...mapState({
            // userdata: (state) => state.userInfo.userinfo,
        }),
        userdata: {
            get() {
                return this.$store.state.userInfo.userinfo
            },
            set(val) {
                this.$store.state.userInfo.userinfo = val
            },
        },
        channelCodeValue() {
            return this.$store.state.config.channelCodeValue
        },
        verifyChannel() {
            return this.userdata.phone ? 'phone' : 'email'
        },
        verifySignupType() {
            return this.pwdVerifyType === 'phone' ? 'PHONE' : 'EMAIL'
        },
        verifyLoginName() {
            return this.pwdVerifyType === 'phone' ? this.userdata.phone : this.userdata.email
        },
    },
    mounted() {
        NoTrace.init('captcha-element', 'captcha-button')
    },
    beforeDestroy() {
        clearInterval(interval)
        NoTrace.reset()
    },
    methods: {
        editPwd() {
            if (!this.userdata.phone && !this.userdata.email) {
                this.bindAccountDia = true
            } else {
                this.pwdVerifyType = this.verifyChannel
                this.editPwdDia = true
            }
        },
        toggleVerifyType() {
            this.pwdVerifyType = this.pwdVerifyType === 'phone' ? 'email' : 'phone'
            this.resetYzm()
            this.$nextTick(() => {
                this.$refs.codeForm && this.$refs.codeForm.resetFields()
            })
            this.codeForm.code = ''
        },
        handlePasswordMethod(type) {
            this.bindAccountDia = false
            if (type === 'oldPwd') {
                this.pwdVerifyType = this.verifyChannel
                this.editPwdDia = true
                this.$nextTick(() => {
                    this.editPwdStep = 0
                })
            } else {
                this.$router.push({ path: '/userCenter/association' })
            }
        },
        async submodify(modify) {
            zhuge.track('用户中心_修改密码提交', { 渠道: this.channelCodeValue })
            this.$refs[modify].validate(async (valid) => {
                var that = this
                if (valid) {
                    await recover({
                        signupType: that.verifySignupType,
                        code: that.codeForm.code,
                        loginName: that.verifyLoginName,
                        password: hexMD5(that.modify.password),
                    })
                        .then((res) => {
                            that.$msg('修改密码成功，请重新登录', 'success')
                            setTimeout(() => {
                                that.$store.commit('userInfo/setuserinfo', null)
                                localStorage.removeItem('queryData')
                                window.location.href = '/api/logout'
                            }, 2000)
                        })
                        .catch((err) => {
                            that.$msg(err.message)
                        })
                } else {
                    return false
                }
            })
        },
        annul() {
            if (this.$getlocalStorage('userData').parentId !== '0') {
                this.$msg('请联系主账号进行账号删除')
                return false
            }
            let that = this
            if (that.userdata.phone || that.userdata.email) {
                this.pwdVerifyType = this.verifyChannel
                that.diaIdentity = true
                zhuge.track('用户中心_注销账号', { 渠道: this.channelCodeValue })
            } else {
                that.noAnnulDia = true
            }
        },
        async getVerificationCode() {
            this.getCode()
            var that = this
            that.disabled = true

            // 开始获取无痕验证码
            NoTrace.start(
                (nvc) => {
                    this.nvc = nvc
                },
                this.executeFun,
                {
                    loginName: this.verifyLoginName,
                    signupType: this.verifySignupType,
                    nvc: '',
                    afsVersion: 2,
                }
            )
        },
        executeFun(params) {
            let that = this
            return new Promise(async (resolve, reject) => {
                try {
                    let res = await sendMsg(params)
                    resolve(res)
                    that.$msg('验证码已发送，请注意接收', 'success')
                } catch (err) {
                    reject(err)
                    that.$msg('发送失败')
                    that.disabled = false
                    clearInterval(interval)
                    that.yzmtext = '获取验证码'
                    that.currentTime = time
                }
            })
        },
        getCode() {
            var that = this
            var currentTime = that.currentTime
            interval = setInterval(function () {
                currentTime--
                that.yzmtext = '(' + currentTime + 's)重新获取'
                if (currentTime <= 0) {
                    clearInterval(interval)
                    that.yzmtext = '重新获取'
                    that.currentTime = 60
                    that.disabled = false
                }
            }, 1000)
        },
        subIdentity(form, n) {
            if (n == 2) {
                zhuge.track('用户中心_注销账户提交', {
                    渠道: this.channelCodeValue,
                    用户行为: '注销账号',
                })
            }
            let that = this
            this.$refs[form].validate((valid) => {
                if (valid) {
                    let data = qs.stringify({
                        loginName:
                            n == 2
                                ? this.userdata.phone
                                    ? this.userdata.phone
                                    : this.userdata.email
                                : this.verifyLoginName,
                        code: n == 2 ? that.yzmForm.yzm : that.codeForm.code,
                    })
                    verifyCode(data)
                        .then((res) => {
                            clearInterval(interval)
                            if (n == 2) {
                                that.$router.push({
                                    name: 'Annul',
                                    params: {
                                        pass: 1,
                                    },
                                })
                            } else {
                                that.editPwdStep = 2
                            }
                        })
                        .catch((err) => {
                            that.resetYzm()
                            that.$msg(err.message)
                        })
                }
            })
        },
        resetYzm() {
            clearInterval(interval)
            this.nvc = ''
            this.yzmtext = '获取验证码'
            this.disabled = false
            this.currentTime = 61
        },
        subModifyPwd(ref) {
            zhuge.track('用户中心_原密码修改密码提交', { 渠道: this.channelCodeValue })
            this.$refs[ref].validate(async (valid) => {
                if (valid) {
                    await changePassword({
                        oldPassword: hexMD5(this.modifyPwd.oldPassword),
                        newPassword: hexMD5(this.modifyPwd.confirmPwd),
                    })
                        .then((res) => {
                            if (res && res.id) {
                                this.$msg('修改密码成功，请重新登录', 'success')
                                setTimeout(() => {
                                    this.$store.commit('userInfo/setuserinfo', null)
                                    localStorage.removeItem('queryData')
                                    window.location.href = '/api/logout'
                                }, 2000)
                            }
                        })
                        .catch((err) => {
                            this.$msg(err.message)
                        })
                } else {
                    return false
                }
            })
        },
    },
}
</script>

<style scoped lang="less">
.tel {
    margin-top: 27px;
    height: 40px;
    padding-left: 10px;

    p {
        float: left;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333;
        margin-top: 10px;
    }

    .el-button {
        padding: 11px 42px;
        border-color: #3f7df7;
        float: right;
        color: #3f7df7;
    }
}
.copyDialog {
    /deep/ .el-dialog__header {
        padding: 10px 20px 10px;
        .el-dialog__headerbtn {
            top: 10px;
        }
    }
    /deep/ .el-dialog__footer {
        padding-bottom: 30px;
    }
    .headerImg {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        margin: auto;
    }

    .changeUser {
        width: 24px;
        height: 22px;
    }

    .el-col-3 {
        display: flex;
        justify-content: center;
        align-self: center;
    }

    p {
        margin-top: 10px;
        text-align: left;
    }

    .yzphone {
        margin-bottom: 15px;
    }

    .el-button {
        padding: 12px 23px;
        margin: 0 20px;
    }

    .demo-ruleForm {
        p {
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #3f7df7;
            line-height: 35px;
            cursor: pointer;
        }
    }

    .videntity {
        margin-bottom: 10px;
        line-height: 25px;
        b {
            color: #3f7df7;
        }
    }
    .changeBind {
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 15px;
        span {
            color: #3f7df7;
            cursor: pointer;
        }
    }
    .verify-switch-item {
        color: #3f7df7;
        cursor: pointer;
        white-space: nowrap;
    }
    .verify-divider {
        color: #dcdfe6;
        margin: 0 12px;
        user-select: none;
    }
    .hint {
        p {
            text-align: center;
            .el-icon-ali-jinggao {
                font-size: 45px;
                color: #ff6610;
                margin-bottom: 10px;
            }
        }
    }
}
.copyDialog2 .copyDialog3 {
    /deep/ .el-dialog__body {
        padding-bottom: 0;
    }

    .next {
        background: #fff;
    }
}

.copyDialog3 {
    .copyDialog3Code {
        /deep/ .el-input__inner {
            border-radius: 22px 0 0 22px;
        }

        /deep/ .el-input-group__append {
            border-radius: 0 22px 22px 0;
            cursor: pointer;
            padding: 0;
        }

        /deep/ .el-input-group__append .yzm {
            display: block;
            padding: 0 20px;
            color: #3f7df7;
        }

        /deep/ .el-input-group__append .yzm[disabled] {
            color: #c8c8c8;
            pointer-events: none;
        }
    }
    .copyDialog3ipt {
        /deep/ .el-input__inner {
            border-radius: 22px;
        }
    }
}
.pwd-option-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 15px 20px 25px;

    li {
        border: 1px solid #d9d9d9;
        cursor: pointer;
        border-radius: 4px;
        transition: all 0.2s;
        width: 290px;

        &:hover {
            border-color: #3f7df7;
            background: #f9fbff;
        }

        dl {
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 20px 30px;
            height: 91px;

            dd {
                margin-left: 19px;
                h3 {
                    font-size: 16px;
                    margin-bottom: 9px;
                    color: #333;
                    font-weight: 400;
                }
                span {
                    font-size: 14px;
                    color: #666;
                }
            }
        }
    }
}
</style>
